import angular from "angular";
import core from "../../core/core.module";
import mobiusHandler from "../mobius-handler";

angular
    .module('mobiusControl.errorHandlers', [core, mobiusHandler])
    .component('errorHandlers', {
        controller: ['notifier', 'MobiusHandler', controller],
        template: require('./error-handlers.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(notifier, MobiusHandler) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.mobiusError = $ctrl.resolve.mobiusError;

        $ctrl.conditions = [
            ['code', 'message', 'request_slug'],
            ['code', 'message'],
            ['code']
        ];

        $ctrl.handlers = window.angular.copy($ctrl.mobiusError.handlers);
    };

    $ctrl.submit = function (ind, isDelete) {

        if (isDelete && !confirm('Вы действительно хотите удалить обработчик?')) {
            return;
        }

        let cond = $ctrl.conditions[ind];

        let params = {
            errorType: 'client_error',
            errorCode: cond.indexOf('code') != -1 ? $ctrl.mobiusError.code : null,
            errorMessage: cond.indexOf('message') != -1 ? $ctrl.mobiusError.message : null,
            requestSlug: cond.indexOf('request_slug') != -1 ? $ctrl.mobiusError.request_slug : null,
            message: $ctrl.handlers[ind],
            isDelete: !!isDelete
        };

        let loadingKey = 'handlerLoading' + ind;

        $ctrl.mobiusError[loadingKey] = true;

        MobiusHandler
            .toggleByParams(params)
            .then(
                function () {
                    $ctrl.mobiusError[loadingKey] = false;
                    if (isDelete) {
                        $ctrl.handlers[ind] = null;
                        $ctrl.mobiusError.handlers[ind] = null;
                        $ctrl.mobiusError.handlersCount--;
                        notifier.successNotify('Оброботчик успешно удален');
                    } else {
                        if (!$ctrl.mobiusError.handlers[ind]) {
                            $ctrl.mobiusError.handlersCount++;
                        }
                        $ctrl.mobiusError.handlers[ind] = $ctrl.handlers[ind];
                        notifier.successNotify('Данные успешно сохранились');
                    }
                },
                function (error) {
                    $ctrl.mobiusError[loadingKey] = false;
                    notifier.errorResponseNotify(error);
                }
            );
    };
}

export default 'mobiusControl.errorHandlers';



// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/error-handlers/error-handlers.js